import type { ConsultationType } from '@forgd/shared/schemas/consultation'

export const CONSULTATION_APP_PATH = '/consultation'
export const CONSULTATION_TYPE_QUERY_KEY = 'type'
export const CONSULTATION_MARKET_MAKER_TYPE: ConsultationType = 'market-maker'

export type ConsultationDestinationType = ConsultationType

export interface ConsultationDestination {
  to: string
  external: boolean
  target: '_blank' | undefined
}

export function resolveConsultationDestination(
  consultationType: ConsultationDestinationType = 'project',
): ConsultationDestination {
  const to =
    consultationType === CONSULTATION_MARKET_MAKER_TYPE
      ? `${CONSULTATION_APP_PATH}?${CONSULTATION_TYPE_QUERY_KEY}=${CONSULTATION_MARKET_MAKER_TYPE}`
      : CONSULTATION_APP_PATH

  return { to, external: false, target: undefined }
}

export function normalizeConsultationType(value: unknown): ConsultationDestinationType {
  return value === CONSULTATION_MARKET_MAKER_TYPE ? CONSULTATION_MARKET_MAKER_TYPE : 'project'
}
